/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createEvent = /* GraphQL */ `
  mutation CreateEvent(
    $input: CreateEventInput!
    $condition: ModelEventConditionInput
  ) {
    createEvent(input: $input, condition: $condition) {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const updateEvent = /* GraphQL */ `
  mutation UpdateEvent(
    $input: UpdateEventInput!
    $condition: ModelEventConditionInput
  ) {
    updateEvent(input: $input, condition: $condition) {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const deleteEvent = /* GraphQL */ `
  mutation DeleteEvent(
    $input: DeleteEventInput!
    $condition: ModelEventConditionInput
  ) {
    deleteEvent(input: $input, condition: $condition) {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const createExternalEvent = /* GraphQL */ `
  mutation CreateExternalEvent(
    $input: CreateExternalEventInput!
    $condition: ModelExternalEventConditionInput
  ) {
    createExternalEvent(input: $input, condition: $condition) {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const updateExternalEvent = /* GraphQL */ `
  mutation UpdateExternalEvent(
    $input: UpdateExternalEventInput!
    $condition: ModelExternalEventConditionInput
  ) {
    updateExternalEvent(input: $input, condition: $condition) {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const deleteExternalEvent = /* GraphQL */ `
  mutation DeleteExternalEvent(
    $input: DeleteExternalEventInput!
    $condition: ModelExternalEventConditionInput
  ) {
    deleteExternalEvent(input: $input, condition: $condition) {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
